import React, { useState, useCallback } from 'react'
import { Input, CheckBox } from '../../Form/Form'
import Button from 'react-bootstrap/Button'
import Box from './Styled/Box'
import Controllers from '../../../Api/Controllers'
import Helpers from '../../Helpers/Helpers'
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom'

const Login = () => {

  const { type } = useParams()

  const isLoginCustomers = type === 'clientes'

  const [session, setSession] = useState({
    username: Helpers.config.isDeveloperWeb() ? (isLoginCustomers ? '1' : 'administrador') : '',
    password: Helpers.config.isDeveloperWeb() ? '1234' : '',
  })

  const dataSubmit = useCallback(() => {
    return { 
      p_username: session.username,
      p_password: session.password,
      p_type: isLoginCustomers ? 1 : 2
    }
  }, [session])

  const handleSubmit = e => {
    e.preventDefault()
    let $this = e.target

    if (!$this.checkValidity()) {
      $this.classList.add('was-validated')
    } else {
      $this.classList.remove('was-validated')

      let button = $this.querySelector('button');
      let buttonHTML = button.innerHTML;
      button.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
      
      Controllers.users.get_login(dataSubmit()).then(res => {
        Helpers.toast.construct({ ...res, toast });
        if (res.response === 'success') {
          Helpers.localStorage.setSession({
            jwt: res.data.jwt
          });
          window.location.href = Helpers.config.convertUrl({ url: '/' });
        } else {
          button.innerHTML = buttonHTML;
        }
      }).catch(req => {
        Helpers.promise.catch({req, toast });
        button.innerHTML = buttonHTML;
      });
    }
  }

  const Logo = Helpers.config.resourcesUrl({ url: '/images/dashboard/logo-color.png' })

  return <Box>
    <Box.Container>
      <Box.Content>
        <div className="text-center mb-4">
          <Box.Logo src={Logo} alt="Lebiom" />
        </div>

        <div className="text-center mb-4">
          <p style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: '#5b4a3a', fontWeight: 700, marginBottom: '0.5rem' }}>
            {isLoginCustomers ? 'Clientes' : 'Administración'}
          </p>
          <h2 style={{ fontWeight: 700, color: '#2c2a20', fontSize: '1.6rem', marginBottom: '0.4rem' }}>
            Iniciar sesión
          </h2>
          <p style={{ color: '#7a7265', fontSize: '0.88rem', marginBottom: 0 }}>
            Ingresa tus credenciales para continuar.
          </p>
        </div>

        <form onSubmit={handleSubmit} autoComplete="off" className="needs-validation" noValidate>
          <div className="form-row">
            <Input
              text="Usuario"
              placeholder="Nombre de usuario"
              icon="fa fa-user"
              classNameParent="col-12 mb-3"
              required
              defaultValue={session.username}
              onChange={e => setSession({ ...session, username: e.currentTarget.value })}
              size=""
            />
            <Input type="password" 
              text="Contraseña"
              placeholder="Contraseña"
              icon="fa fa-lock"
              classNameParent="col-12 mb-2"
              required
              defaultValue={session.password}
              onChange={e => setSession({ ...session, password: e.currentTarget.value })}
              size=""
            />
            <CheckBox text="Recordarme" defaultChecked={false} classNameParent="col-12" id="remember_me" />
            <div className="col-12 mt-4">
              <Button type="submit" variant="success" size="" block style={{
                height: '50px',
                fontSize: '0.85rem',
                letterSpacing: '0.06em'
              }}>
                INGRESAR
              </Button>
            </div>
          </div>
        </form>
      </Box.Content>

      <p className="text-center mt-3" style={{ color: '#7a7265', fontSize: '0.75rem' }}>
        © {new Date().getFullYear()} Lebiom. Todos los derechos reservados.
      </p>
    </Box.Container>
  </Box>
}

export default Login
